import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../service/global.service';

@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.css']
})
export class RegionComponent implements OnInit {

  constructor(private GlobalService: GlobalService) {
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit(): void {
  }

}
